import React from 'react'
import { StepWrapper } from '../../style'
import { SectionHeader, Textarea } from '@base'
import { strings } from '@constants'

const TermsConditions = ({ state2, valueChangeHandler }) => {
	return (
		<StepWrapper>
			<SectionHeader>Terms and Conditions</SectionHeader>
			<Textarea
				id='quote-message'
				type='text'
				rows={5}
				placeholder={strings('msg_share_any_more_details')}
				value={state2?.enquiryQuote?.terms_and_conditions}
				onChange={valueChangeHandler(null, 'terms_and_conditions')}
			/>
		</StepWrapper>
	)
}

export default TermsConditions
